import React, { useState } from 'react';
import { connect } from 'react-redux';
import Snackbar from '../../components/Snackbar';
import BillingTable from '../../components/Tables/BillingTable'
import BillingList from '../../components/MyMembership/Billing/components/BillingList';
import './Invoices.scss'
import SendInvoice from '../../components/Modal/SendInvoice';

export const Invoices = ({billing}) => {
  const [open, setOpen] = useState(false);
  const [invoiceToSend, setInvoiceTosend] = useState('');
  const handleClose = () => {
    setOpen(false);
  };

  const handleSendInvoice = (id) => {
    setInvoiceTosend(id);
    setOpen(true);
  };

  const invoiceData = false;

  return (
    <div className="invoices-container">
      <div className="invoices-container-title">
        <p>Facturas</p>
        {/* <button className="invoices-container-button">
          Generar factura
        </button> */}
      </div>

      {true ? 
        <>
          <div className="invoices-container-table">
            <BillingTable handleSendInvoice={handleSendInvoice} invoicesData={billing}/>
          </div> 
          <div className="invoices-container-list">
            <BillingList handleSendInvoice={handleSendInvoice} invoicesData={billing} />
          </div>
        </>
        :
        <div className="invoices-container-empty">
          <p>No hay elementos para mostrar</p>
        </div>
      }

      <SendInvoice
        open={open}
        handleClose={handleClose} 
        invoiceToSend={invoiceToSend}
      />
    </div>
  );
};




const mapStateToProps = (state) => ({
  invoicesData: state.authClient.membershipData.cards
});

export default connect(mapStateToProps, null)(Invoices);


